<div class="invoice-skus">
  <form [formGroup]="form">
    <mat-card class="lum-mat-card">
      <div class="invoice-skus__actions flex gap-2 justify-end">
        <div class="flex gap-2 grow">
          <button
            type="button"
            class="lum-button lum-button--secondary"
            (click)="onOpenSkuDialog()"
            [disabled]="isInvoiceStatusComplete"
          >
            <lum-ui-icon
              color="#5563d6"
              width="10"
              height="10"
              class="mr-2"
              icon="add-circle"
            ></lum-ui-icon>
            Add New SKU
          </button>
          <button
            type="button"
            class="lum-button lum-button--secondary"
            (click)="onOpenVariantSkuDialog()"
            [disabled]="isInvoiceStatusComplete"
          >
            <lum-ui-icon
              color="#5563d6"
              width="10"
              height="10"
              class="mr-2"
              icon="add-circle"
            ></lum-ui-icon>
            Add New Variant SKU
          </button>
          <button
            *ngIf="packageManagementEnabled"
            type="button"
            class="lum-button lum-button--secondary"
            (click)="onSavePackage()"
            [disabled]="isInvoiceStatusComplete"
          >
            <lum-ui-icon
              color="#5563d6"
              width="18"
              height="18"
              class="mr-2"
              icon="content-save"
            ></lum-ui-icon>
            Save Invoice Template
          </button>
        </div>
        <button
          type="button"
          class="lum-button lum-button--tertiary"
          (click)="fileInput.click()"
          [disabled]="isInvoiceStatusComplete"
        >
          <lum-ui-icon
            color="#36363a"
            width="10"
            height="10"
            class="mr-2"
            icon="upload-button-2"
          ></lum-ui-icon>
          Upload
        </button>
        <input
          type="file"
          accept=".csv"
          style="display: none"
          (change)="onFileSelected($event)"
          #fileInput
          [disabled]="isInvoiceStatusComplete"
        />
        <a href="/assets/templates/purchase-order-upload-template.csv">
          <button
            type="button"
            class="lum-button lum-button--tertiary"
            [disabled]="isInvoiceStatusComplete"
          >
            <lum-ui-icon
              color="#36363a"
              width="10"
              height="10"
              class="mr-2"
              icon="download-button"
            ></lum-ui-icon>
            Download Template
          </button>
        </a>
        <button
          type="button"
          class="lum-button"
          (click)="onOpenLineItemsDialog()"
          [disabled]="isInvoiceStatusComplete"
        >
          <lum-ui-icon
            width="10"
            height="10"
            class="mr-2"
            icon="add-circle"
          ></lum-ui-icon>
          Add Multiple Line Items
        </button>

        <lum-invoice-package-dropdown
          *ngIf="packageManagementEnabled && !isInvoiceStatusComplete"
          #packageDropdown
          (applyPackage)="onApplyPackage($event)"
        ></lum-invoice-package-dropdown>
      </div>

      <div class="flex mt-4">
        <div class="flex grow">
          <div class="scan-mode-container w-99 mt-7">
            <lum-rfq-scan-mode-input
              [loading]="(loading$ | async) || false"
              [rfqs]="rfqs"
              [debounceTime]="0"
              [scanSearchStr]="scanSearchStr"
              (inputChangeEvent)="onSearchRfqs($event, true)"
              (selectSkuEvent)="onSelectSku($event)"
              [disabled]="isInvoiceStatusComplete"
            ></lum-rfq-scan-mode-input>
          </div>
        </div>
        <div
          *ngIf="lineItemsFormArray?.length"
          class="flex justify-content-end gap-2"
        >
          <button
            *ngIf="hasSelectedItems"
            type="button"
            class="lum-button lum-button--secondary mt-7"
            mat-button
            [matMenuTriggerFor]="menu"
            [disabled]="isInvoiceStatusComplete"
          >
            Bulk Update
            <lum-ui-icon class="ml-2" icon="edit" color="#5563d6"> </lum-ui-icon>
          </button>
          <mat-menu class="lum-mat-menu" #menu="matMenu">
            <button mat-menu-item (click)="onBulkUpdateUOM()">
              Bulk Update UOM
            </button>
            <button (click)="onBulkUpdateQuantity()" mat-menu-item>
              Bulk Update Quantity
            </button>
            <ng-container *ngIf="isOverridden">
              <button (click)="onBulkUpdatePrice()" mat-menu-item>
                Bulk Update Price
              </button>
              <button (click)="onBulkUpdateDiscountAmount()" mat-menu-item>
                Bulk Update Discount Amount
              </button>
              <button (click)="onBulkUpdateDiscountPercent()" mat-menu-item>
                Bulk Update Discount Percent
              </button>
            </ng-container>
          </mat-menu>
          <button
            type="button"
            class="lum-button lum-button--secondary mt-7"
            mat-button
            (click)="onOverrideChange(!isOverride)"
            [disabled]="isInvoiceStatusComplete"
          >
            {{ isOverride ? 'Reset Override' : 'Override' }}
            <lum-ui-icon
              class="ml-2"
              icon="{{ isOverride ? 'time-rewind' : 'edit' }}"
              color="#5563d6"
            >
            </lum-ui-icon>
          </button>
          <div class="w-80">
            <div class="lum-label">Price Level</div>

            <mat-select
              class="lum-select"
              formControlName="price_level_id"
              [disabled]="isInvoiceStatusComplete"
            >
              <mat-option value="">--None--</mat-option>
              <mat-option
                *ngFor="let level of pricingLevels; trackBy: trackById"
                [value]="level.id"
                >{{ level.name }}</mat-option
              >
            </mat-select>
          </div>
        </div>
      </div>

      <div class="mt-4">
        <ng-container>
          <div class="invoice-skus__filters flex gap-2 mt-4">
            <input
              type="text"
              placeholder="Search SKU or Product Name in Line Items Table..."
              matInput
              class="lum-input"
              (input)="onSearchInputChange($event)"
            />

            <div class="grow-0 shrink-0 px-2">
              <button
                type="button"
                class="lum-button lum-button--secondary lum-button--large"
                [matMenuTriggerFor]="menu"
                #trigger="matMenuTrigger"
              >
                Columns ({{ displayColumnCount }})
              </button>

              <mat-menu class="lum-mat-menu" #menu="matMenu">
                <ng-container *ngFor="let column of displayColumns">
                  <mat-checkbox
                    #menuItems
                    class="
                      lum-checkbox lum-checkbox--menu
                      d-block py-3 hover:gray-100
                    "
                    name="menu_filters"
                    [checked]="column.visible"
                    (click)="onToggleColumn($event, column)"
                  >
                    {{ column.label }}
                  </mat-checkbox>
                </ng-container>
              </mat-menu>
            </div>
          </div>

          <lum-invoice-skus-table
            [form]="form"
            [discountEntries]="discountEntries"
            [creditMemos]="creditMemos"
            [templateId]="templateId"
            [currentInvoice]="currentInvoice"
            [discountAmount]="discountAmount"
            [searchableFields]="searchableFields"
            [searchStr]="searchStr"
            [rfqs]="rfqs"
            [columns]="displayColumns"
            [loadingRfqs]="loadInitialRfq || false"
            [fromEnterEvent]="fromEnterEvent"
            [isInvoiceStatusComplete]="isInvoiceStatusComplete"
            (removeLineItem)="onRemoveLineItem($event)"
            (removeCreditMemoEntry)="removeCreditMemoEntry.emit($event)"
            (addRowItems)="onAddRowItems($event)"
            (addRowItemSubTotal)="addRowItemSubTotal.emit($event)"
            (addInvoiceCreditMemoEntry)="onAddInvoiceCreditMemoEntry($event)"
            (selectRfq)="selectRfq.emit($event)"
            (selectCreditMemo)="selectCreditMemo.emit($event)"
            (enterRfqEvent)="onEnterRfqEvent($event)"
            (searchRfq)="onSearchRfqs($event, false)"
            (scrollPaginate)="onPaginateRfqs()"
            (recalculateSubtotals)="recalculateSubtotals.emit()"
          ></lum-invoice-skus-table>
        </ng-container>
      </div>
    </mat-card>
  </form>
</div>
